module.exports = __webpack_public_path__ + "static/media/my-enquiry.584acd01.svg";